import {Component, HTMLProps} from 'react'

import { getSvgError } from './icons/svg'

import { isEmpty } from '../validation/stringRegex'

export interface BaseProps extends HTMLProps<HTMLElement> {
    // callBack --- aggiorna il padre!
    callback?: Function,
    // attributi obbligatori
    id: string | undefined,
    className?: string | undefined,
    // altro
    label?: string,
    error?: string,
    errorDisplayMsg?: string
}

export interface BaseState {
    // potrebbe rendersi necessaria la gestioe di errori dal sotto stato?
    validationError?: string | undefined
}

export class BaseComponent <T extends BaseProps, P extends BaseState>
    extends Component<T,P> {

        mergedProps : T | undefined

        constructor(props: any){ 
            super(props) 

            this.mergedProps = undefined
        }

        /**
         * Ritorna la differenza tra due oggetti (tutte le proprieta in obj1 non presenti in obj2)
         * @param obj1 l'oggetto da cui prendere gli attributi
         * @param obj2 l'oggetto da confrontare
         * @returns la differenza obj1 - obj2
         */
        getPropertyDifferences (obj1: Object, obj2: Object) {
            return Object.entries(obj1).reduce((diff, [key, value]) => {
                // Check if the property exists in obj2.
                if (!obj2.hasOwnProperty(key)) {
                    return {
                        ...diff,
                        [key]: value,
                    }
                }

                // Otherwise, just return the previous diff object.
                return diff
            }, {})
        }

        /**
         * Stampa l'eventuale messaggio di errore
         * @returns il messaggio di error sse props.error è valorizzato
         */
        getError () {
            const error = this.props.error ?? this.state?.validationError

            return ( error !== undefined )
                ?   <span className='alert alert-danger'>
                        {getSvgError()}
                        <span>{error}</span>
                    </span>
                : undefined
        }

        getTextError () {
            return this.props.error ?? this.state?.validationError
        }

        /**
         * Stampa l'eventuale label
         * @returns una label sse props.label && this.props.id sono valorizzati
         */
        getLabel () {
            const hasError = (this.props.error ?? this.state?.validationError)
            const labelClass = (hasError !== undefined) ? 'is-invalid form-label' : 'form-label'

            return ( this.props.label && this.props.id )
                ?   <label 
                        className={labelClass}
                        htmlFor={`${this.props.id}`}
                    >
                        {hasError && getSvgError()}
                        {this.props.label}
                    </label>
                :   undefined
        }

        getCheckLabel () {
            return ( this.props.label && this.props.id )
                ?   <label 
                        className='form-check-label'
                        htmlFor={`${this.props.id}`}
                    >
                        {this.props.label}
                    </label>
                :   undefined
        }

        getSelectionLabel () {
            const hasError = (this.props.error ?? this.state?.validationError)
            const labelClass =  (hasError !== undefined) ? 'is-invalid form-label' : 'form-label'

            return ( this.props.label && this.props.id )
                ?   <label 
                        className={labelClass}
                        htmlFor={`${this.props.id}`}
                    >
                        {hasError && getSvgError()}
                        {this.props.label}
                    </label>
                :   undefined
        }

        notEmpty (msg: string | undefined) {
            return !isEmpty(msg)
        }
}